import { render } from "./CreateMessage.vue?vue&type=template&id=c7fdfc4c&scoped=true"
import script from "./CreateMessage.vue?vue&type=script&lang=js"
export * from "./CreateMessage.vue?vue&type=script&lang=js"

import "./CreateMessage.vue?vue&type=style&index=0&id=c7fdfc4c&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fdfc4c"]])

export default __exports__